import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
// Icons for navigation and social media
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from 'react-icons/fa';
import { HiChevronRight } from 'react-icons/hi';
import axiosInstance from '../../utils/axiosInstance';

const Footer = () => {
  const [categories, setCategories] = useState([]);

  // 1. Fetch categories when the component mounts
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const { data } = await axiosInstance.get('/categories');
        // Sort by sequence to ensure correct order
        setCategories(data.sort((a, b) => a.sequence - b.sequence));
      } catch (error) {
        console.error("Failed to fetch categories for footer:", error);
      }
    };
    fetchCategories();
  }, []);

  // 2. Split the categories array for the two columns
  const quickLinkCategories = categories.slice(0, 4);
  const importantLinkCategories = categories.slice(4, 9);

  return (
    <footer className="bg-gray-800 text-gray-300 py-10">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Brand Section */}
          <div className="w-full">
            <h2 className="text-3xl font-bold mb-4 text-white">Our Blog</h2>
            <p className="text-sm">
              Welcome to Our Blog, where we share interesting articles, tutorials, and the latest updates in technology, lifestyle, and more!
            </p>
          </div>

          {/* Quick Links Section */}
          <div className="w-full">
            <h3 className="text-xl font-bold mb-4 text-white">Quick Links</h3>
            <ul className="space-y-2">
              <li><FooterLink to="/" icon={<HiChevronRight />} text="Home" /></li>
              <li><FooterLink to="/blogs" icon={<HiChevronRight />} text="Blogs" /></li>
              {/* Render the first 4 categories */}
              {quickLinkCategories.map(cat => (
                <li key={cat.id}>
                  <FooterLink to={`/blogs?category=${cat.id}`} icon={<HiChevronRight />} text={cat.name} />
                </li>
              ))}
            </ul>
          </div>

          {/* Important Links Section */}
          <div className="w-full">
            <h3 className="text-xl font-bold mb-4 text-white">Important Links</h3>
            <ul className="space-y-2">
                {/* Render the next 5 categories */}
              {importantLinkCategories.map(cat => (
                <li key={cat.id}>
                  <FooterLink to={`/blogs?category=${cat.id}`} icon={<HiChevronRight />} text={cat.name} />
                </li>
              ))}
              <li><FooterLink to="/about" icon={<HiChevronRight />} text="About Us" /></li>
              <li><FooterLink to="/contact" icon={<HiChevronRight />} text="Contact" /></li>
            </ul>
          </div>

          {/* Social Media Section */}
          <div className="w-full">
            <h3 className="text-xl font-bold mb-4 text-white">Follow Us</h3>
            <div className="flex space-x-4">
              <SocialLink href="https://facebook.com" icon={<FaFacebook size={24} />} />
              <SocialLink href="https://twitter.com" icon={<FaTwitter size={24} />} />
              <SocialLink href="https://instagram.com" icon={<FaInstagram size={24} />} />
              <SocialLink href="https://linkedin.com" icon={<FaLinkedin size={24} />} />
            </div>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-6 text-center text-sm">
          <p>&copy; {new Date().getFullYear()} Our Blog. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

// Helper component for consistent link styling
const FooterLink = ({ to, icon, text }) => (
  <Link to={to} className="flex items-center gap-2 hover:text-white transition duration-300">
    {icon}
    <span>{text}</span>
  </Link>
);

// Helper component for consistent social icon styling
const SocialLink = ({ href, icon }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" className="transform hover:scale-110 hover:text-white transition duration-300">
    {icon}
  </a>
);

export default Footer;